// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/source-avatar/source-avatar.component.scss
// module id = 224
// module chunks = 0